import NearService from "../NearService";

export default function Connected() {
    return function (_: object, __: string | symbol, descriptor: PropertyDescriptor) {
        const originalMethod = descriptor.value;

        descriptor.value = async function (this: NearService, ...args: unknown[]) {
            await this.connect();
            return originalMethod.apply(this, args);
        };

        return descriptor;
    };
}
